import { render, staticRenderFns } from "./AttrNClock.vue?vue&type=template&id=059d1f76&scoped=true"
import script from "./AttrNClock.vue?vue&type=script&lang=js"
export * from "./AttrNClock.vue?vue&type=script&lang=js"
import style0 from "./AttrNClock.vue?vue&type=style&index=0&id=059d1f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d1f76",
  null
  
)

export default component.exports